<template>
  <PgForm
    ref="formRef"
    :formItems="formItems"
    :model="model"
    :extendCompileData="extendCompileData"
    @scroll.native="scroll"
  ></PgForm>
</template>
<script setup>
import { PgForm } from '../../form/index'
import { useScroll } from '../hook/use-scroll'
import { ref, onMounted } from 'vue'

const props = defineProps({
  formItems: Object,
  model: Object,
  extendCompileData: Object,
  onComplete: Function,
  property: String,
})

const formRef = ref(null)
const { scroll } = useScroll()

onMounted(() => {
  props.onComplete?.(props.property, async (tableValid) => {
    const formErrors = await formRef.value.validate()
    const tableErrors = await tableValid(props.formItems.items.map((im) => im.property))
    return tableErrors ?? formErrors
  })
})

defineExpose({
  validate() {
    return formRef.value?.validate()
  },
})
</script>
